import {
    IWarehouseTypes,
    WarehouseTypesResponseType
} from '@/entity/warehouse/Type/Warehouse.type.types'

export default class StoreTypes implements IWarehouseTypes {
    id:number;
    name:string;
    constructor (data: WarehouseTypesResponseType){
        this.id = data.id;
        this.name = data.name;
    }
}